// TOUR-4a — poll until a tour anchor appears in the DOM (post mode-switch).

import { queryFireflyTargetById } from "./fireflyTargetConvention.js";

export type WaitForFireflyTargetOptions = {
  timeoutMs?: number;
  intervalMs?: number;
};

export function waitForFireflyTarget(
  targetId: string,
  options: WaitForFireflyTargetOptions = {},
): Promise<HTMLElement | null> {
  const timeoutMs = options.timeoutMs ?? 2_500;
  const intervalMs = options.intervalMs ?? 80;

  if (typeof document === "undefined") {
    return Promise.resolve(null);
  }

  return new Promise((resolve) => {
    const started = Date.now();

    const tick = () => {
      const el = queryFireflyTargetById(targetId);
      if (el) {
        resolve(el);
        return;
      }
      if (Date.now() - started >= timeoutMs) {
        resolve(null);
        return;
      }
      window.setTimeout(tick, intervalMs);
    };

    tick();
  });
}
